import { render, staticRenderFns } from "./teacherManage.vue?vue&type=template&id=2a815b94&scoped=true&"
import script from "./teacherManage.vue?vue&type=script&lang=js&"
export * from "./teacherManage.vue?vue&type=script&lang=js&"
import style0 from "./teacherManage.vue?vue&type=style&index=0&id=2a815b94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a815b94",
  null
  
)

export default component.exports